import { render, staticRenderFns } from "./organ.vue?vue&type=template&id=983781f8&scoped=true"
import script from "./organ.vue?vue&type=script&lang=ts"
export * from "./organ.vue?vue&type=script&lang=ts"
import style0 from "./organ.vue?vue&type=style&index=0&id=983781f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983781f8",
  null
  
)

export default component.exports